<template>
  <div class="warningTop">
    <div v-for="(item,index) of TopList" :key="index" :class="[ change == index ? 'TopStateColor' : 'TopState' ]" @click="TopClick(index,item)">
      {{ item.Text }}
      <div></div>
    </div>
    <SearchComm placeholder="证件名称/订单名称/合同名称" @searchClick="searchClick" :width="300"></SearchComm>
  </div>
</template>

<script>
import SearchComm from '../../../../../components/comm-from-search'
export default {
  components: { SearchComm },
  props: {
    TopList: {
      type: Array
    }
  },
  data() {
    return {
      change: 0,
      WarningSearch: ""
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    // 顶部切换
    TopClick(index, item) {
      if (this.change != index) {

        this.change = index
      }
      this.$emit('TopClick', item)
    },
    // 搜索
    searchClick(value) {
      this.$emit('searchClick', value)      //console.log("kjjjj", value);
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.warningTop {
  width: 100%;
  height: 64px;
  background-color: #ffffff;
  position: relative;
  user-select: none;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #eaecef;

  .TopState {
    display: inline-block;
    line-height: 64px;
    margin-left: 32px;
    font-size: 14px;
    font-weight: 500;
    color: #9ca5b8;
    position: relative;
    cursor: pointer;

    div {
      display: inline-block;
      height: 15px;
      width: 1px;
      background-color: #cfd6e6;
      margin-left: 16px;
      position: relative;
      top: 2px;
    }
  }
}
.TopStateColor {
  display: inline-block;
  line-height: 64px;
  margin-left: 32px;
  font-size: 14px;
  font-weight: 500;
  color: #e71d43;
  position: relative;
  cursor: pointer;
  div {
    display: inline-block;
    height: 15px;
    width: 1px;
    background-color: #cfd6e6;
    margin-left: 16px;
    position: relative;
    top: 2px;
  }
}
</style>